import React, { createContext, useContext, useState } from "react";

interface HomeContextType {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  sectionCount: number;
  scrollTarget: number | null;
  setScrollTarget: (page: number | null) => void;
}

const HomeContext = createContext<HomeContextType | undefined>(undefined);

export const HomeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [scrollTarget, setScrollTarget] = useState<number | null>(null);
  const sectionCount = 4; // Hero, About, Socials, Credit/Game

  return (
    <HomeContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        sectionCount,
        scrollTarget,
        setScrollTarget,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export const useHome = () => {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error("useHome must be used within a HomeProvider");
  }
  return context;
};
